import { passwordRequirements } from '~/models/passwordRequirements';
import { SecurityService } from '../../../../services/security.service';
import { UserSummary } from './../../../../models/administration/user';
import { PasswordService } from '~/services/identity/password';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AfterViewInit, Component, Inject, OnInit, ViewChild, ElementRef, ChangeDetectorRef, AfterContentChecked, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { Subscription } from 'rxjs';
import { UsersService } from '~/services/administration.ts/users';
import { LocationsService } from '~/services/modules/stocks/locations';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';

@Component({
    selector: 'app-reset-password-popup',
    templateUrl: './reset-password-popup.component.html',
    styleUrls: ['./reset-password-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResetPasswordPopupComponent implements OnInit, OnDestroy {

  _theme: string;
  _popupSub!: Subscription;
  _active: boolean = true;
  _form: FormGroup;
  Password: string = '';
  _email: string = '';
  hasComplexPassword: boolean = false;
  RequireAutomaticPassword: any;
  RequireUserChangePassword: any;
  EmailSignInfo: any;
  ResetPasswordType: any;
  _pageName: string = '';
  PasswordStrengthDescription: string;
  fieldTextType: boolean = false;
  isAdmin: boolean;
  _currentUser: UserSummary;
  _passwordRequirements: passwordRequirements;
  _usersList: any = [];
  _usersListFiltered: any = [];
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('Kendo_Combobox_Users') Kendo_Combobox_Users: ComboBoxComponent;
  constructor(private _themeManager: ThemeManagerService,
    private _layoutComponent: LayoutComponent,
    private _sharedService: SharedService,
    private _fb: FormBuilder,
    private _passwordService: PasswordService,
    private _securityService: SecurityService,
    private _usersService: UsersService,
    @Inject(PORTAL_DATA) public data: any,
    private cdref: ChangeDetectorRef) {
    this._form = this._fb.group({
      Password: new FormControl(''),
      EmailTo: new FormControl(''),
      ResetPasswordType: new FormControl(),
      RequireAutomaticPassword: new FormControl(),
      RequireUserChangePassword: new FormControl(),
      EmailSignInfo: new FormControl(),
    });

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._getUsers();

    if (data) {
      if (data.model.email)
        this._email = data.model.email;
      if (data.model.hasComplexPassword)
        this.hasComplexPassword = data.model.hasComplexPassword;
      // else (data.model.batch)
      //   this._batch = data.model.batch;
      // this._pageName = data.model.pageName;
    }
    this._currentUser = this._securityService.currentUser;
    this.isAdmin = this._currentUser.appRole.name === "Admin";
  }

  ngAfterViewInit(): void {

  }
  ngOnDestroy(): void {
    if (this._popupSub) this._popupSub.unsubscribe();
  }
  _initForm() {
    this._form = this._fb.group({
      // Password: new FormControl('',
      // //[Validators.required, Validators.minLength(9), Validators.maxLength(256)]
      // ),
      Password: new FormControl(''),
      EmailTo: new FormControl(''),
      ResetPasswordType: new FormControl(),
      RequireAutomaticPassword: new FormControl(),
      RequireUserChangePassword: new FormControl(),
      EmailSignInfo: new FormControl(),

    });

    this._passwordRequirements = {
      atLeastChar: {
        text: 'Must include at least 6 characters',
        valid: ''
      },
      notIncludeSpaces: { text: '', valid: '' },
      includeSpecial: { text: '', valid: '' },
      includeLowercase: { text: '', valid: '' },
      includeNumeric: { text: '', valid: '' },
      includeUppercase: { text: '', valid: '' },
    };
  }
  // getAuth() {
  //   this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)
  //     
  //     .subscribe((x: GridFieldAuthorization[]) => {
  //       this._gridFieldAuth = x;
  //       this.setStatusFieldsCount();
  //     });
  // }
  // getAuthByLabel(objectCode: any) {
  //   if (this._gridFieldAuth) {
  //     if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
  //       var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
  //     else
  //       result = null

  //     return result ? result : new GridFieldAuthorization();
  //   }
  // }

  ngOnInit(): void {
    this._initForm();
  }
  ngAfterContentChecked() {

    this.cdref.detectChanges();

  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  _closeForm() {
    this._active = false;
    var closeComponent = {
      //response: response,
      component: 'reset-password-popup',
      isClosed: true
    }
    this._active = false;
    //this._gridLayoutManagerService.setGridDataSubjects('users');
    // this._layoutManager.setFromChanged('users');
    //this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
  }
  _onStateChanges(e: any) {
    // var element: any = this.kendoMainWindow;
    // if (e === 'minimized') {
    //   element.el.nativeElement.classList.remove('fullWidthFormForm');
    // } else if (e === 'maximized') {
    //   element.el.nativeElement.classList.remove('fullWidthFormForm');
    // } else if (e === 'default') {
    //   element.el.nativeElement.classList.add('fullWidthFormForm');
    // }
  }
  OnSelectCheckbox(value: any) {
    this._form.controls.ResetPasswordType.setValue(value);
    this._form.controls.RequireAutomaticPassword.setValue(false)
    this._form.controls.RequireUserChangePassword.setValue(false)
    this._form.controls.EmailSignInfo.setValue(false)
    if (value == 1) {
      this._form.controls.RequireAutomaticPassword.setValue(true)
    }
    if (value == 2) {
      this._form.controls.RequireUserChangePassword.setValue(true)
    }
    if (value == 3) {
      this._form.controls.EmailSignInfo.setValue(true)
    }
  }
  PasswordValidation(password: any) {
    let ValidationMessage = "";
    if (!password) {
      ValidationMessage = "Password is required";
      return ValidationMessage;
    }
    else if (password) {
      const hasInvalidChar = /[^a-zA-Z0-9!_.#$%&*@]/.test(password);
      if (hasInvalidChar) {
        ValidationMessage = "Password contains invalid special characters. Allowed special characters are: ! _ . # $ % & * @";
        return ValidationMessage;
      }

      if (this.hasComplexPassword) {
        if (password.length < 9 || password.length > 256) {
          ValidationMessage = "Password must be between 9 and 256 characters";
          return ValidationMessage;
        }
        const hasLower = /[a-z]/.test(password);
        const hasUpper = /[A-Z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSymbol = /[!_.#$%&*@]/.test(password);
        if (!hasLower || !hasUpper || !hasNumber || !hasSymbol) {
          ValidationMessage = "Password must use a combination of the following uppercase letters, lowercase letters, numbers, and symbols";
          return ValidationMessage;
        }
      }
      else {
        if (password.length < 6) {
          ValidationMessage = "Password Must include at least 6 characters";
          return ValidationMessage;
        }
      }
    }

  }
  _onSave() {
    if (this._popupSub) this._popupSub.unsubscribe();
    this._popupSub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {

      if (data) {


        let model = {
          Email: this._email,
          Password: this._form.value.Password,
          ResetPasswordType: this._form.value.ResetPasswordType,
          EmailTo: this._form.value.EmailTo,
          HasComplexPassword: this.hasComplexPassword,
        }
        this._passwordService
          .resetFromUserForm(model)

          .subscribe((data: any) => {
            if (data.success == true) {
              if (model.ResetPasswordType == 1) {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: 'Password for this email ' + this._email + ' has been changed successfully ',
                  withoutConfirm: true
                });
              }
              if (model.ResetPasswordType == 2) {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: 'User with email  ' + this._email + ' will be required to reset password on sign in',
                  withoutConfirm: true
                });
              }
              if (model.ResetPasswordType == 3) {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: 'An email has been sent to ' + this._form.value.EmailTo,
                  withoutConfirm: true
                });
              }
              this._closeForm();
            }
            else {
              if (model.ResetPasswordType == 1) {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: 'Invalid Password.',
                  withoutConfirm: true
                });
              }
              if (model.ResetPasswordType == 2) {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: 'Error.',
                  withoutConfirm: true
                });
              }
              if (model.ResetPasswordType == 3) {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: 'Invalid email.',
                  withoutConfirm: true
                });
              }
            }


          },
            (error: any) => {
              if (model.ResetPasswordType == 1) {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: 'Invalid Password.',
                  withoutConfirm: true
                });
              }
              if (model.ResetPasswordType == 2) {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: 'Error.',
                  withoutConfirm: true
                });
              }
              if (model.ResetPasswordType == 3) {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: 'Invalid email.',
                  withoutConfirm: true
                });
              }

              // this.error = 'Invalid email.';
            });

      }
    });
    //this._popupSub.unsubscribe();
    if (!this._form.value.ResetPasswordType) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: "Please choose Reset Password Type",
        withoutConfirm: true
      });
      return;
    }
    if (this._form.value.ResetPasswordType == 1) {
      let PasswordValidationMessage = this.PasswordValidation(this._form.value.Password)
      if (PasswordValidationMessage) {

        this._layoutComponent.openPopup({
          title: 'Validation',
          message: PasswordValidationMessage,
          withoutConfirm: true
        });
        return;
      }
    }
    if (this._form.value.ResetPasswordType == 3) {
      if (!this._form.value.EmailTo) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: "Email is required",
          withoutConfirm: true
        });
        return;
      }

    }
    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to proceed with the changes?',
    });
  }
  PasswordValidateObject: any = {};
  passwordStrengthObject(event: boolean) {
    this.PasswordValidateObject = event;
  }
  _getUsers() {
    this._usersService.getUsersList().subscribe((data: any) => {

      this._usersList = data;
      this._usersListFiltered = this._usersList;
    });
  }

  _handleUsersFilter(value: any) {
    this._usersListFiltered = this._usersList.filter(
      (s: any) => s.userName.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
}
